import { Box, styled } from '@mui/material';
var StyledModalContentContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    padding: theme.spacing(0, 3)
  };
  return styles;
});
export { StyledModalContentContainer };